// React
import { memo } from 'react'

// Components
import { BaseLabel } from 'components'

// Antd
import { CloseOutlined, DeleteOutlined, SyncOutlined } from '@ant-design/icons'

// Uploady
import { FILE_STATES } from '@rpldy/chunked-uploady'

// Constant
import { ANOTHER_FILE_STATES } from 'constant/file.constant'

// Interfaces
import { IPreviewActionButtonsProps } from './interfaces'

const PreviewActionButtons = memo(({ withLabel, file, onAbort, onChange, onRetry }: IPreviewActionButtonsProps) => {
  return (
    <div className="flex justify-between mb-2">
      {withLabel && <BaseLabel label={file.file.name} fontSize={14} />}
      <div className="flex items-center">
        {/* Render cancel button */}
        {file.state === FILE_STATES.UPLOADING && (
          <CloseOutlined
            style={{ cursor: 'pointer', color: '#ff5858', fontSize: 14 }}
            onClick={event => {
              event.stopPropagation()

              onAbort(file.id)
            }}
          />
        )}

        {/* Delete Button */}
        {[FILE_STATES.ERROR, FILE_STATES.ABORTED, FILE_STATES.CANCELLED, FILE_STATES.FINISHED].includes(file.state) && (
          <DeleteOutlined
            style={{ cursor: 'pointer', color: '#ff5858', fontSize: 14 }}
            onClick={event => {
              event.stopPropagation()

              onChange(ANOTHER_FILE_STATES.DELETE, file)
            }}
          />
        )}

        {/* Retry Button */}
        {[FILE_STATES.ERROR, FILE_STATES.ABORTED, FILE_STATES.CANCELLED].includes(file.state) && (
          <SyncOutlined
            className="ml-3"
            style={{ cursor: 'pointer', color: '#0055fa', fontSize: 14 }}
            onClick={event => {
              event.stopPropagation()

              onRetry(file.id)
            }}
          />
        )}
      </div>
    </div>
  )
})

export { PreviewActionButtons }
